'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

const map = exports.map = function (f) {
  return function (x) {
    return x.map(f);
  };
};

const head = exports.head = function (x) {
  return x[0];
};

const Identity = exports.Identity = function (x) {
  return x;
};

const isObject = exports.isObject = function (o) {
  return typeof o === 'object';
};

const isObjectObject = function (o) {
  return o != null && isObject(o) && !Array.isArray(o);
};

const isPlainObject = exports.isPlainObject = function (o) {
  if (isObjectObject(o) === false) return false;
  if (typeof o.constructor !== 'function') return false;
  if (isObjectObject(o.constructor.prototype) === false) return false;
  if (o.constructor.prototype.hasOwnProperty('isPrototypeOf') === false) return false;
  return true;
};

const mapFilter = exports.mapFilter = function (f) {
  return function (x) {
    const output = [];
    const input = x.slice();
    let xi;
    while (xi = input.shift()) {
      const result = f(xi);
      if (typeof result !== 'undefined') output.push(result);
    }
    return output.length ? output : void 0;
  };
};

const pathFilter = exports.pathFilter = function (f) {
  return function (x) {
    const output = [];
    let i = 0,
        xi;
    while (xi = x[i]) {
      const result = f(xi);
      if (result) output.push([i]);
      i++;
    }
    return output;
  };
};

const searchFor = exports.searchFor = function (o, p) {
  let visited = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Set();

  let result = [];
  if (visited.has(o)) return result;
  visited.add(o);
  for (const k in o) {
    if (k === p) result = result.concat(o[k]);
    if (isPlainObject(o[k]) || Array.isArray(o[k])) result = result.concat(searchFor(o[k], p, visited));
  }
  return result;
};

const searchForPath = exports.searchForPath = function (o, p) {
  let ps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  let visited = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new Set();

  let result = [];
  if (visited.has(o)) return result;
  visited.add(o);
  const coerce = Array.isArray(o) ? Number : function (x) {
    return x;
  };
  for (const k in o) {
    if (k === p) result = result.concat([ps.concat(coerce(k))]);
    if (isPlainObject(o[k]) || Array.isArray(o[k])) result = result.concat(searchForPath(o[k], p, ps.concat(coerce(k)), visited));
  }
  return result;
};

const join = exports.join = function (paths, to) {
  if (!to.length) return paths;
  const result = [];
  for (const p of paths) {
    for (const t of to) {
      result.push([].concat(_toConsumableArray(t), _toConsumableArray(p)));
    }
  }
  return result;
};

const slicePaths = exports.slicePaths = function (x, start) {
  let end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : x.length;

  let i = start;
  const output = [];
  while (i < end) {
    output.push([i]);
    i++;
  }
  return output;
};